/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespComplementaryItemsGrid_item$ref = any;
export type PdpRespSimilarItemsFooter_item$ref = any;
export type PdpRespSimilarItemsFooter_item = {
    readonly isArt: boolean | null;
    readonly serviceId: string | null;
    readonly " $fragmentRefs": PdpRespComplementaryItemsGrid_item$ref;
    readonly " $refType": PdpRespSimilarItemsFooter_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSimilarItemsFooter_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isArt",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespComplementaryItemsGrid_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'd5a05d2479dd73a9dded3b023516f419';
export default node;
